import SVGAddress from "@/lib/svg/SVGAddress";
import SVGMail from "@/lib/svg/SVGMail";
import SVGPhone from "@/lib/svg/SVGPhone";
import {
  ContactsContainer,
  Heading,
  Info,
  Subheading,
  ContactBlock,
  Label,
  IconWrapper,
  Address,
  Email,
  Phone,
  LabelText,
} from "./styles";
import { useTranslation } from "@/lib/translations";
import { useRouter } from "next/router";

export type ContactsProps = {
  heading?: string;
  subheading?: string;
  email?: string;
  phone?: string;
  address?: string;
};

const Contacts: React.FC<ContactsProps> = (props) => {
  const { heading, subheading, email, phone, address } = props;

  const { locale = "it" } = useRouter();
  const t = {
    addressLabel: useTranslation("marketingPage.location.address", locale),
    emailLabel: useTranslation("marketingPage.location.email", locale),
    phoneLabel: useTranslation("marketingPage.location.phone", locale),
  };

  return (
    <ContactsContainer>
      {heading && <Heading>{heading}</Heading>}
      <Info>
        {subheading && <Subheading>{subheading}</Subheading>}
        {t.addressLabel && address && (
          <ContactBlock>
            <Label>
              <IconWrapper>
                <SVGAddress />
              </IconWrapper>
              <LabelText>{t.addressLabel}:</LabelText>
            </Label>
            <Address>{address}</Address>
          </ContactBlock>
        )}
        {t.emailLabel && email && (
          <ContactBlock>
            <Label>
              <IconWrapper>
                <SVGMail />
              </IconWrapper>
              <LabelText>{t.emailLabel}:</LabelText>
            </Label>
            <Email>{email}</Email>
          </ContactBlock>
        )}
        {t.phoneLabel && phone && (
          <ContactBlock>
            <Label>
              <IconWrapper>
                <SVGPhone />
              </IconWrapper>
              <LabelText>{t.phoneLabel}:</LabelText>
            </Label>
            <Phone>{phone}</Phone>
          </ContactBlock>
        )}
      </Info>
    </ContactsContainer>
  );
};

export default Contacts;
